import { render, staticRenderFns } from "./answerParse.vue?vue&type=template&id=3607d9b6&scoped=true&"
import script from "./answerParse.vue?vue&type=script&lang=js&"
export * from "./answerParse.vue?vue&type=script&lang=js&"
import style0 from "./answerParse.vue?vue&type=style&index=0&id=3607d9b6&prod&lang=scss&scoped=true&"
import style1 from "./answerParse.vue?vue&type=style&index=1&id=3607d9b6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3607d9b6",
  null
  
)

export default component.exports